import React, { useState, useEffect } from "react";

import styled from "styled-components";

import { Switch, Route, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Portfolio from "./components/Portfolio";
import Resume from "./components/Resume";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import NotFound from "./components/NotFound";

// Styles
import GlobalStyles from "./styles/GlobalStyle";

// Portals
import GraphicDesign from "./components/Portals/GraphicDesign";
import BrandDesign from "./components/Portals/BrandDesign";
import PackagingDesign from "./components/Portals/PackagingDesign";
import SocialMedia from "./components/Portals/SocialMedia";
import AppDevelopment from "./components/Portals/AppDevelopment";
import WebDevelopment from "./components/Portals/WebDevelopment";
import FurnitureDesign from "./components/Portals/FurnitureDesign";
import InteriorDesign from "./components/Portals/InteriorDesign";
import ArchitecturalDesign from "./components/Portals/ArchitecturalDesign";
import Paintings from "./components/Portals/Paintings";

// Pages
// Graphic Design
import Dansn from "./components/Portfolio/GraphicDesign/Dansn";

// Branding Design
import ChristjinJason from "./components/Portfolio/BrandDesign/ChristjinJason";

//Social Media
import Bloved from "./components/Portfolio/SocialMedia/Bloved";
import Esterel from "./components/Portfolio/SocialMedia/Esterel";
import Coc from "./components/Portfolio/SocialMedia/Coc";
import Freek from "./components/Portfolio/SocialMedia/FreekNietsche";
import Hesselink from "./components/Portfolio/SocialMedia/Hesselink";
import Josephine from "./components/Portfolio/SocialMedia/Josephine";
import Josh from "./components/Portfolio/SocialMedia/JoshV";
import Koetshuis from "./components/Portfolio/SocialMedia/Koetshuis";
import Prescan from "./components/Portfolio/SocialMedia/Prescan";
import Showtime from "./components/Portfolio/SocialMedia/Showtime";
import Stef from "./components/Portfolio/SocialMedia/Stef";
import Total from "./components/Portfolio/SocialMedia/Total";

const Container = styled.div`
  margin: 0;
  padding: 0;
  transition: color 0.5s, background-color 0.5s;
  color: #000000;
`;

const Content = styled.div`
  min-height: calc(100vh - 3.5rem);
  max-width: 100%;
  margin: 0 auto;
  margin-top: 3.4rem;
  margin-bottom: -3.5rem;
  z-index: 10;
  filter: ${(props) => (props.isOpen ? "blur(0.2rem)" : "none")};
`;

const App = () => {
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    console.log(scroll);
    document.addEventListener("scroll", () => {
      setScroll(window.scrollY > 1);
    });
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  let path = useLocation().pathname;
  const location = path.split("/")[1];
  //console.log(location);
  useEffect(() => {
    let title = path.substring(3);
    if (!title) {
      title = "home";
    }

    if (
      title !== "about" &&
      title !== "resume" &&
      title !== "portfolio" &&
      title !== "portfolio/graphic_design" &&
      title !== "portfolio/graphic_design/dansn" &&
      title !== "portfolio/branding_design" &&
      title !== "portfolio/branding_design/christjin_jason" &&
      title !== "portfolio/packaging_design" &&
      title !== "portfolio/social_media" &&
      title !== "portfolio/social_media/bloved" &&
      title !== "portfolio/social_media/esterel" &&
      title !== "portfolio/social_media/coc_ta" &&
      title !== "portfolio/social_media/freek_nietsche" &&
      title !== "portfolio/social_media/hesselink" &&
      title !== "portfolio/social_media/josephine" &&
      title !== "portfolio/social_media/josh_v" &&
      title !== "portfolio/social_media/koetshuis" &&
      title !== "portfolio/social_media/prescan" &&
      title !== "portfolio/social_media/showtime" &&
      title !== "portfolio/social_media/stef" &&
      title !== "portfolio/social_media/total" &&
      title !== "portfolio/app_development" &&
      title !== "portfolio/web_development" &&
      title !== "portfolio/furniture_design" &&
      title !== "portfolio/interior_design" &&
      title !== "portfolio/architectural_design" &&
      title !== "portfolio/paintings" &&
      title !== "contact" &&
      title !== "home"
    ) {
      title = "404";
    }
    document.title =
      title[0].toUpperCase() + title.slice(1) + " | " + "Hemme.rs";
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [path]);

  return (
    <div>
      <GlobalStyles />
      <Container location={location}>
        <Navbar
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          scroll={scroll}
          location={location}
        />
        <main>
          <Content isOpen={isOpen}>
            <Switch>
              <Route exact path="/" component={Home}>
                <Home />
              </Route>

              <Route exact strict path="/about" component={About}>
                <About />
              </Route>

              <Route exact path="/resume" component={Resume}>
                <Resume />
              </Route>

              <Route exact path="/portfolio" component={Portfolio}>
                <Portfolio />
              </Route>

              {/* Portfolio Graphic Design */}
              <Route
                exact
                path="/portfolio/graphic_design"
                component={GraphicDesign}
              >
                <GraphicDesign />
              </Route>

              <Route
                exact
                strict
                path="/portfolio/graphic_design/dansn"
                component={Dansn}
              >
                <Dansn />
              </Route>

              {/* Portfolio Brand Design */}
              <Route
                exact
                path="/portfolio/brand_design"
                component={BrandDesign}
              >
                <BrandDesign />
              </Route>

              <Route
                exact
                strict
                path="/portfolio/brand_design/christjin_jason"
                component={ChristjinJason}
              >
                <ChristjinJason />
              </Route>

              {/* Portfolio Packaging Design */}
              <Route
                exact
                path="/portfolio/packaging_design"
                component={PackagingDesign}
              >
                <PackagingDesign />
              </Route>
              {/* Portfolio Social Media */}
              <Route
                exact
                path="/portfolio/social_media"
                component={SocialMedia}
              >
                <SocialMedia />
              </Route>
              <Route
                exact
                path="/portfolio/social_media/bloved"
                component={Bloved}
              >
                <Bloved />
              </Route>
              <Route
                exact
                path="/portfolio/social_media/esterel"
                component={Esterel}
              >
                <Esterel />
              </Route>

              <Route
                exact
                path="/portfolio/social_media/coc_ta"
                component={Coc}
              >
                <Coc />
              </Route>

              <Route
                exact
                path="/portfolio/social_media/freek_nietsche"
                component={Freek}
              >
                <Freek />
              </Route>

              <Route
                exact
                path="/portfolio/social_media/hesselink"
                component={Hesselink}
              >
                <Hesselink />
              </Route>

              <Route
                exact
                path="/portfolio/social_media/josephine"
                component={Josephine}
              >
                <Josephine />
              </Route>

              <Route
                exact
                path="/portfolio/social_media/josh_v"
                component={Josh}
              >
                <Josh />
              </Route>

              <Route
                exact
                path="/portfolio/social_media/koesthuis"
                component={Koetshuis}
              >
                <Koetshuis />
              </Route>

              <Route
                exact
                path="/portfolio/social_media/prescan"
                component={Prescan}
              >
                <Prescan />
              </Route>

              <Route
                exact
                path="/portfolio/social_media/showtime"
                component={Showtime}
              >
                <Showtime />
              </Route>

              <Route exact path="/portfolio/social_media/stef" component={Stef}>
                <Stef />
              </Route>
              <Route
                exact
                path="/portfolio/social_media/total"
                component={Total}
              >
                <Total />
              </Route>

              {/* Portfolio App Dev */}
              <Route
                exact
                path="/portfolio/app_development"
                component={AppDevelopment}
              >
                <AppDevelopment />
              </Route>

              {/* Portfolio Web Dev */}
              <Route
                exact
                path="/portfolio/web_development"
                component={WebDevelopment}
              >
                <WebDevelopment />
              </Route>

              {/* Portfolio Furniture Design */}
              <Route
                exact
                path="/portfolio/furniture_design"
                component={FurnitureDesign}
              >
                <FurnitureDesign />
              </Route>

              {/* Portfolio Interior Design */}
              <Route
                exact
                path="portfolio/interior_Design"
                component={InteriorDesign}
              >
                <InteriorDesign />
              </Route>

              {/* Portfolio Arch Design */}
              <Route
                exact
                path="/portfolio/architectural_Design"
                component={ArchitecturalDesign}
              >
                <ArchitecturalDesign />
              </Route>

              {/* Portfolio Paintings */}
              <Route exact path="/portfolio/paintings" component={Paintings}>
                <Paintings />
              </Route>

              <Route exact path="/contact" component={Contact}>
                <Contact />
              </Route>

              <Route component={NotFound} />
            </Switch>
          </Content>
        </main>
        <Footer location={location} />
      </Container>
    </div>
  );
};

export default App;
